























































































































































































































import {
  defineComponent, reactive, computed, ref, onMounted, watch, Ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import PrettyCheck from 'pretty-checkbox-vue/check';

import optionProduct from '@/table/product';
import useStoreProduct from '@/useStoreProduct';
import useAxios from '@/useAxios';
import {
  newStore,
  getStores,
  deleteStore,
  getStore,
  updateStore,
  getProducts,
  deleteProduct,
  updateProduct,
  deleteStoreImage,
} from '@/api/index';

import CommonFormWithRoleEditor from '@/components/User/CommonFormWithRoleEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import NotFound from '@/components/NotFound.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonFormWithRoleEditor,
    NotFound,
    CommonDropzoneWithAxios,
  },
  setup() {
    const { route, router } = useRouter();
    const { axios } = useAxios();
    const edit = ref(false);
    const successModal = ref(null);
    const storeEditorModal = ref(null);
    const refetchQuery = ref(false);
    const { getValidUrl } = useStoreProduct();
    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    const stores: Ref<any[]> = ref([]);
    const page = ref(1);
    const paginatorInfo = ref({
      current_page: 1,
      total: 0,
      last_page: 1,
    });
    async function getStoresData(loadMore = false) {
      const result = (await getStores({
        withDeactive: true,
        orderBy: [
          { field: 'favorite', order: 'DESC' },
          { field: 'order', order: 'ASC' },
        ],
        'page[size]': 100,
      }));

      if (loadMore) stores.value = [...stores.value, ...result.data];
      else stores.value = [...result.data];
      paginatorInfo.value.current_page = result.current_page;
      paginatorInfo.value.total = result.total;
      paginatorInfo.value.last_page = result.last_page;
    }

    const store = reactive({
      name: '',
      redirectUrl: '',
      active: true,
      favorite: true,
      image: '',
      order: '',
      price: '0',
    });

    async function getStoreData(id: number) {
      const result = (await getStore(id));
      store.name = result.name;
      store.redirectUrl = result.redirect_url;
      store.active = result.active;
      store.favorite = result.favorite;
      store.image = result.image;
      store.order = result.order;
      refetchQueryHandler();
    }

    const form = reactive({
      id: -1,
      name: '',
      redirectUrl: '',
      active: true,
      favorite: false,
      image: '',
      order: 0,
      call: async () => {
        if (!edit.value) {
          await newStore({
            name: form.name,
            redirectUrl: getValidUrl(form.redirectUrl),
            active: form.active,
            favorite: form.favorite,
            order: form.order,
          });
          (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
        } else {
          await updateStore(form.id, {
            name: form.name,
            redirectUrl: getValidUrl(form.redirectUrl),
            active: form.active,
            favorite: form.favorite,
            order: form.order,
          });
          (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
          if (parseInt(form.id as any, 10) === parseInt(route.value.params.id, 10)) await getStoreData(route.value.params.id);
        }
        await getStoresData();
      },
      state: {
        value: 'READY',
      },
    });
    function handleUploadDone(data: any) {
      form.image = data.image;
    }
    const toggleVariables = reactive({
      id: -1,
      status: true,
    });
    async function setActiveStatus(id: any, status: boolean) {
      toggleVariables.id = id;
      toggleVariables.status = status;
    }
    const products = ref([]);

    onMounted(async () => {
      getStoresData();
    });

    const deleteStoreModal = ref(null);
    async function deleteStoreAction(id: number) {
      await deleteStore(id);
      await getStoresData();
    }
    const computedPossibleOrder = computed(() => [...Array(stores.value.length)].map((v: any, index: number) => index + 1));

    function clear() {
      form.id = -1;
      form.name = '';
      form.redirectUrl = '';
      form.active = true;
      form.favorite = false;
      form.image = '';
    }
    async function updateActiveStore(id: number, payload: any) {
      await updateStore(id, payload);
      await getStoresData();
    }
    async function deleteProductTable(productId: number) {
      const result = (await deleteProduct(route.value.params.id, productId)).data;
      refetchQueryHandler();
    }
    async function updateActiveFavoriteProduct(isActive: boolean, isFavorite: boolean, productId: number) {
      await updateProduct(productId, {
        active: isActive,
        favorite: isActive ? isFavorite : false,
      });
      refetchQueryHandler();
    }

    watch(() => route.value.params.id, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) await getStoreData(newVal);
    });

    const deleteImageModal = ref(null);
    async function deleteImageAction(ctx: { id: any }) {
      await deleteStoreImage(ctx.id);
      await getStoreData(route.value.params.id);
    }
    const openDeleteImageModal = (id: number) => {
      (deleteImageModal.value as any).compose({ id, action: 'ลบ', entity: 'รูปภาพ' });
    };

    function pendingEditStore(storeFn: any) {
      edit.value = true;
      (storeEditorModal.value as any).open();
      form.id = storeFn.id;
      form.name = storeFn.name;
      form.redirectUrl = storeFn.redirect_url;
      form.active = storeFn.active;
      form.favorite = storeFn.favorite;
      form.image = storeFn.image;
      form.order = storeFn.order !== 0 ? storeFn.order : stores.value.length;
    }

    return {
      axios,

      successModal,

      storeEditorModal,
      pendingEditStore,

      edit,
      form,

      setActiveStatus,

      optionProduct,
      stores,

      deleteStoreModal,
      deleteStoreAction,

      getStoreData,
      clear,
      store,

      products,
      refetchQuery,
      getProducts,
      refetchQueryHandler,
      handleUploadDone,
      updateActiveStore,
      deleteProductTable,
      updateActiveFavoriteProduct,

      deleteImageModal,
      deleteImageAction,
      openDeleteImageModal,

      computedPossibleOrder,
    };
  },
});

export default List;
